"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ChartItem(_ref) {
  var data = _ref.data,
      index = _ref.index;
  return /*#__PURE__*/_react.default.createElement("g", {
    x: data.x,
    y: data.y,
    height: 49,
    className: "chart-series-group chart-color-".concat(index)
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: data.plotX,
    y: data.plotY,
    width: data.plotWidth,
    height: "25",
    className: "chart-plot"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: data.barX,
    y: data.barY,
    width: data.barWidth,
    height: "25",
    className: "chart-bar chart-color-".concat(index)
  }), /*#__PURE__*/_react.default.createElement("text", {
    x: data.legendX,
    y: data.legendY,
    fontSize: "14px",
    className: "chart-bar-legend"
  }, data.range), data.triangles.map(function (item, i) {
    return /*#__PURE__*/_react.default.createElement("polygon", {
      points: item,
      className: "chart-triangle chart-color-".concat(i)
    });
  }));
}

ChartItem.propTypes = {
  data: _propTypes.default.shape({
    x: _propTypes.default.number,
    y: _propTypes.default.number,
    plotX: _propTypes.default.number,
    plotY: _propTypes.default.number,
    plotWidth: _propTypes.default.number,
    barX: _propTypes.default.number,
    barY: _propTypes.default.number,
    barWidth: _propTypes.default.number,
    legendX: _propTypes.default.number,
    legendY: _propTypes.default.number,
    range: _propTypes.default.string,
    triangles: _propTypes.default.arrayOf(_propTypes.default.string).isRequired
  }),
  index: _propTypes.default.number
};
ChartItem.defaultProps = {
  data: {
    triangles: []
  },
  index: undefined
};
var _default = ChartItem;
exports.default = _default;